import { render, staticRenderFns } from "./SocialSeriesTitle.vue?vue&type=template&id=568d9fc5&scoped=true&"
import script from "./SocialSeriesTitle.vue?vue&type=script&lang=js&"
export * from "./SocialSeriesTitle.vue?vue&type=script&lang=js&"
import style0 from "./SocialSeriesTitle.vue?vue&type=style&index=0&id=568d9fc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568d9fc5",
  null
  
)

export default component.exports